import { CheckCircle, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { usePaymentSuccessPage } from './PaymentSuccessPage.logic'

export function PaymentSuccessPage() {
  const { t, isReady, isLoading, handleGoToDashboard } = usePaymentSuccessPage()

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="mx-auto mb-4 flex size-16 items-center justify-center rounded-full bg-green-100">
            <CheckCircle className="size-8 text-green-600" />
          </div>
          <CardTitle className="text-2xl">{t('success.title')}</CardTitle>
          <CardDescription>{t('success.description')}</CardDescription>
        </CardHeader>
        <CardContent>
          {isLoading || !isReady ? (
            <div className="flex flex-col items-center gap-2">
              <Loader2 className="size-6 animate-spin" />
              <p className="text-sm text-muted-foreground">{t('success.activating')}</p>
            </div>
          ) : (
            <Button onClick={handleGoToDashboard} className="w-full" size="lg">
              {t('success.goToDashboard')}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
